import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import { validateSession } from '../utils/functions';
import { navigateTo } from '../utils/navigation';
import { listTournaments, createTournament, ESTADO_TORNEO } from '../utils/tournamentsApi';
import TournamentCreateModal from '../components/TournamentCreateModal';

// Listado de torneos SUELTOS — los que no cuelgan de un evento con venta de entradas.
// Sirve para correr un campeonato que no está cargado como evento; el torneo de un evento
// se entra desde la pantalla del evento y comparte todo lo demás (mismo modelo, mismas
// pantallas), sólo cambia de dónde salen los participantes.
class TournamentsPage extends Component {

    constructor() {
        const cachedRole = Number(localStorage.getItem('role') || 0);
        super();
        this.state = {
            checked: !!localStorage.getItem('token'),
            role: cachedRole,
            loading: true,
            tournaments: [],
            creating: false,
            error: null,
            form: false,
        };
    }

    async componentDidMount() {
        const role = await validateSession(true);
        this.setState({ checked: true, role });
        this.load();
    }

    load = async () => {
        this.setState({ loading: true, error: null });
        try {
            const data = await listTournaments();
            this.setState({ tournaments: (data && data.tournaments) || [], loading: false });
        } catch (e) {
            this.setState({ error: e.message, loading: false });
        }
    }

    crear = async (payload) => {
        const data = await createTournament(payload);
        // El modal se desmonta ANTES de navegar: es un overlay propio justamente para no
        // arrastrar el backdrop de Bootstrap a la pantalla siguiente, que la deja congelada.
        this.setState({ form: false });
        navigateTo('/tournament?id=' + data.tournament.id);
    }

    fecha = (v) => {
        if (!v) return '—';
        const d = new Date(v);
        return isNaN(d.getTime()) ? '—' : d.toLocaleDateString('es-UY');
    }

    renderFila = (t, index) => {
        const estado = ESTADO_TORNEO[t.status] || { label: t.status, badge: 'badge-secondary' };
        return (
            <tr role="row" key={t.id} style={{ background: index % 2 === 0 ? '#ffffff' : '#fcfcfc' }}>
                <td className="text-left">{t.title || 'Sin nombre'}</td>
                <td className="text-left">
                    {t.event_id ? (
                        <a href={`/editEvent?id=${t.event_id}`} title="Ir al evento">{t.eventTitle || `Evento #${t.event_id}`}</a>
                    ) : <span className="text-muted">Suelto</span>}
                </td>
                <td>{t.game_name || '—'}</td>
                <td>{t.table_size}</td>
                <td>{t.rounds_planned}</td>
                <td><span className={'badge ' + estado.badge}>{estado.label}</span></td>
                <td>{this.fecha(t.created_at)}</td>
                <td className="text-right text-nowrap">
                    <button type="button" className="btn btn-sm btn-white"
                        onClick={() => navigateTo('/tournament?id=' + t.id)}>
                        Abrir
                    </button>
                </td>
            </tr>
        );
    }

    renderCuerpo() {
        if (this.state.loading) {
            return (<tr><td colSpan="8" className="text-center" style={{ padding: 30 }}>Cargando…</td></tr>);
        }
        if (this.state.error) {
            return (<tr><td colSpan="8" className="text-center" style={{ padding: 30, color: '#C4183C' }}>{this.state.error}</td></tr>);
        }
        if (!this.state.tournaments.length) {
            return (
                <tr><td colSpan="8" className="text-center" style={{ padding: 30, color: '#818EA3' }}>
                    Todavía no hay torneos. Creá uno para arrancar.
                </td></tr>
            );
        }
        return this.state.tournaments.map(this.renderFila);
    }

    render() {
        if (!this.state.checked) return (<div></div>);
        return (
            <div className="container-fluid">
                {this.state.form ? (
                    <TournamentCreateModal
                        onCancel={() => this.setState({ form: false })}
                        onCreate={this.crear} />
                ) : null}
                <div className="row">
                    <SidebarComponent itemSelected={36} role={this.state.role} />
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4">
                            <div className="d-flex justify-content-between align-items-center">
                                <HeaderComponent title="Cafetería" subtitle="Torneos" />
                                <button type="button" className="btn btn-accent" disabled={this.state.creating}
                                    onClick={() => this.setState({ form: true })}>
                                    + Nuevo torneo
                                </button>
                            </div>

                            <div className="card card-small mb-4">
                                <div className="card-header border-bottom">
                                    <h6 className="m-0">Torneos</h6>
                                </div>
                                <div className="card-body p-0 pb-3">
                                    <div className="dataTables_wrapper no-footer">
                                        <table className="transaction-history dataTable no-footer dtr-inline" role="grid">
                                            <thead>
                                                <tr role="row">
                                                    <th className="text-left" style={{ width: '24%' }}>Torneo</th>
                                                    <th className="text-left" style={{ width: '20%' }}>Evento</th>
                                                    <th style={{ width: '13%' }}>Juego</th>
                                                    <th style={{ width: '9%' }}>Por mesa</th>
                                                    <th style={{ width: '8%' }}>Rondas</th>
                                                    <th style={{ width: '11%' }}>Estado</th>
                                                    <th style={{ width: '9%' }}>Creado</th>
                                                    <th style={{ width: '6%' }}></th>
                                                </tr>
                                            </thead>
                                            <tbody>{this.renderCuerpo()}</tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default TournamentsPage;
